import styled from 'styled-components';
import BackgroundImage from '../../../BackgroundImage';

const StyledBackgroundImage = styled(BackgroundImage)`
  > img {
    filter: blur(4px);
  }
`;

export default StyledBackgroundImage;
